import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import arrow from '../../assets/images/Arrow 1.png'
function Banner() {
  var settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
     
    ],
  };
  return (
    <>
      <section className="banner-section pt-50">
        <div className="slider_area modern-banner d-flex align-items-center" id="home">
          <Container>
            <Row className="align-items-center">
              <Col lg={7}>
                <div className="banner-content" data-aos="fade-up">
                  <div className="banner-badge mb-4">
                    <span>#1 Innovation Partner</span>
                  </div>
                  <h1 className="banner-title">
                    Digital Excellence for <br />
                    <span className="gradient-text">Leading Enterprises</span>
                  </h1>
                  <p className="banner-desc mt-4">
                    We've delivered 100+ high-impact web and mobile solutions 
                    for the world's most ambitious startups and established enterprises.
                  </p>
                  <div className="banner-actions mt-5 d-flex align-items-center gap-4">
                    <Link className="modern-btn primary" to="/aboutus">
                      Explore Our Story
                    </Link>
                    <div className="banner-arrow-hint d-none d-md-flex">
                      <img src={arrow} alt="arrow" />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <div className="banner-background-decoration"></div>
        </div>
      </section>

    </>
  );
}

export default Banner;
